const TELEGRAM_BASE_URL = "https://t.me/";
const URL_PREFIX = /^(https?:\/\/)?(www\.)?(t\.me|telegram\.me)\//i;

/**
 * Normalize a Telegram nickname: trims it and strips a leading "@" or t.me link prefix.
 * @returns normalized nickname, or `null` if nothing is left.
 */
export const normalizeTelegramNickname = (
  nickname: string | null | undefined
): string | null => {
  if (!nickname) return null;
  const result = nickname
    .trim()
    .replace(URL_PREFIX, "")
    .replace(/^@/, "")
    .trim();
  return result || null;
};

/**
 * Build a `https://t.me/<nickname>` link from a Telegram nickname.
 * @returns link, or `null` if the nickname is empty.
 */
export const getTelegramUrl = (
  nickname: string | null | undefined
): string | null => {
  const normalized = normalizeTelegramNickname(nickname);
  return normalized ? `${TELEGRAM_BASE_URL}${normalized}` : null;
};
